import React from 'react';
import { Linkedin, Instagram, Twitter, Youtube } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();


  const navItems = [
    { key: 'about', href: '#about' },
    { key: 'triangle', href: '#triangle' },
    { key: 'pillars', href: '#pillars' },
    { key: 'services', href: '#services' },
    { key: 'membership', href: '#membership' },
    { key: 'contact', href: '#contact' },
  ];

  const socialLinks = [
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Youtube, href: '#', label: 'YouTube' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer 
      data-testid="footer"
      className="bg-[#1A1F4B] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_commerce-hub-202/artifacts/igxu646q_LOGO%20OFICIAL%20BACC.jpg%20%281%29.jpeg"
                alt="BACC Logo"
                className="h-12 w-12 object-contain rounded-full"
              />
              <div className="font-heading text-2xl font-bold">BACC</div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    data-testid={`social-${social.label.toLowerCase()}`}
                    className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-[#C9A84C] hover:text-[#1A1F4B] transition-colors"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-6">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.key}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                    data-testid={`footer-nav-${item.key}`}
                    className="text-white/60 hover:text-[#C9A84C] transition-colors text-sm"
                  >
                    {t(`nav.${item.key}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-lg mb-6">{t('footer.legal')}</h3>
            <ul className="space-y-3">
              <li>
                <button
                  data-testid="footer-privacy"
                  className="text-white/60 hover:text-[#C9A84C] transition-colors text-sm cursor-default"
                >
                  {t('footer.privacy')}
                </button>
              </li>
              <li>
                <button
                  data-testid="footer-terms"
                  className="text-white/60 hover:text-[#C9A84C] transition-colors text-sm cursor-default"
                >
                  {t('footer.terms')}
                </button>
              </li>
            </ul>
          </div>

          {/* Newsletter / Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-6">{t('footer.social')}</h3>
            <p className="text-white/60 text-sm mb-4">
              Brasil | USA | Asia
            </p>
            <div className="flex items-center gap-2">
              <span className="text-2xl">🇧🇷</span>
              <span className="text-2xl">🇺🇸</span>
              <span className="text-2xl">🌏</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm text-center md:text-left">
            {t('footer.rights')}
          </p>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
